define('viewmodels/pages/faq',['underscore', 'knockout', 'plugins/dialog'], function (_, ko, dialog) {

    var createFaqContentBlock = function(block) {
        var nonEmptyQuestions = ko.observableArray(
            _.filter(block.questions, function(q) {
                return !_.isEqual(q.question, 'empty');
            })
        );

        return {
            headline: ko.observable(block.headline),
            questionsAndAnswers: nonEmptyQuestions
        };
    };

    return function FaqViewModel(faqPageField, FaqDialog, FaqDialogTablet) {
        var self = this;

        self.topBar = ko.observable();
        self.topBarText = faqPageField('page_heading')();

        self.questionGroups = ko.pureComputed(function() {
            var questionGroups = faqPageField('question_group')();

            if (!_.some(questionGroups)) {
                return [];
            }

            return _.map(questionGroups, createFaqContentBlock);
        });

        self.subNav = {
            name: 'faq',
            tabs: ko.observableArray()
        };

        self.showFaqDialog = function(questions) {
            dialog.showDialog(new FaqDialog(questions));
        };

        self.showFaqDialogTablet = function(questionAndAnswer, index) {
            dialog.showDialog(new FaqDialogTablet(questionAndAnswer, index));
        };
    };
});

